export default __webpack_public_path__ + "static/media/9_of_clubs.8e317f62.png";